"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekSelector = void 0;
var React = require("react");
var react_aria_live_1 = require("react-aria-live");
var keyboard = require("../../../_Core/Keyboard");
var Highlighted_1 = require("../../../Highlighted");
var Icons_1 = require("../../../Icons");
var DropList_1 = require("../../../Lists/DropList");
var Localization_1 = require("../../../Localization");
var setAnnouncement_1 = require("../../../setAnnouncement/setAnnouncement");
var YearWeekSelector_styles_1 = require("./YearWeekSelector.styles");
var WeekSelector = function (_a) {
    var Data = _a.Data, MinSelectableDateNumber = _a.MinSelectableDateNumber, OnSearch = _a.OnSearch, OnSearchCancel = _a.OnSearchCancel, OnWeekChange = _a.OnWeekChange, SearchAriaLabel = _a.WeekSearchAriaLabel, AriaLabel = _a.AriaLabel;
    var _b = React.useState(false), showWeekSearch = _b[0], setWeekSearch = _b[1];
    var buttonRef = React.useRef();
    var dropListRef = React.useRef();
    var selectedListItemRef = React.useRef();
    var sayPolitely = setAnnouncement_1.setAnnouncement().sayPolitely;
    var weeks = Data.weeks, value = Data.value, filter = Data.filter;
    var toggleWeekSearch = function () {
        if (Data.filter) {
            OnSearchCancel();
        }
        setWeekSearch(!showWeekSearch);
        if (showWeekSearch) {
            buttonRef.current.focus();
        }
    };
    React.useEffect(function () {
        // when im filtering then read out the results
        if (filter) {
            if (weeks.length === 0) {
                sayPolitely(Localization_1.strings.ChartRangeDropDownPicker_Message_SearchNoResultsFound);
            }
            else if (weeks.length === 1) {
                sayPolitely(Localization_1.strings.ChartRangeDropDownPicker_Message_OneResultFound);
            }
            else {
                sayPolitely(Localization_1.strings.formatString(Localization_1.strings.ChartRangeDropDownPicker_Message_MultipleResultsFound, weeks.length.toString()));
            }
        }
    }, [filter]);
    var handleWeekSelected = function (val) {
        OnWeekChange(val);
    };
    var handleSelectRelative = function (relativeChange) {
        var index = weeks.indexOf(value);
        var newIndex = index + relativeChange;
        if (newIndex < 0) {
            newIndex = 0;
        }
        if (newIndex >= weeks.length) {
            newIndex = weeks.length - 1;
        }
        var newValue = weeks[newIndex];
        handleWeekSelected(newValue);
    };
    var handleKeyPress = function (e) {
        e.stopPropagation();
        if (keyboard.IsUpArrow(e)) {
            handleSelectRelative(-1);
            setWeekSearch(true);
        }
        else if (keyboard.IsDownArrow(e)) {
            handleSelectRelative(1);
            setWeekSearch(true);
        }
        else if (keyboard.IsPageUp(e)) {
            handleSelectRelative(-DropList_1.PageSize);
            setWeekSearch(true);
        }
        else if (keyboard.IsPageDown(e)) {
            handleSelectRelative(DropList_1.PageSize);
            setWeekSearch(true);
        }
        else if (keyboard.IsEnter(e) || keyboard.IsSpace(e)) {
            setWeekSearch(true);
        }
        else if (keyboard.IsEscape(e)) {
            setWeekSearch(false);
        }
    };
    React.useEffect(function () {
        if (showWeekSearch && selectedListItemRef.current) {
            selectedListItemRef.current.scrollIntoView({ block: "nearest" });
        }
    }, [selectedListItemRef.current]);
    var handleOnSearch = function (search) {
        OnSearch(search);
        return Promise.resolve();
    };
    var handleOnSearchCancel = function () {
        OnSearchCancel();
        return Promise.resolve();
    };
    return (React.createElement("div", { style: { overflow: "hidden" } },
        React.createElement(YearWeekSelector_styles_1.CurrentWeekButton, { "aria-label": AriaLabel + " - " + value.Caption, "aria-haspopup": "listbox", "aria-expanded": showWeekSearch, ref: buttonRef, onClick: toggleWeekSearch, onKeyUp: handleKeyPress },
            React.createElement(YearWeekSelector_styles_1.CurrentWeekButtonSpan, null, value.Caption),
            React.createElement(react_aria_live_1.LiveAnnouncer, null,
                React.createElement(react_aria_live_1.LiveMessage, { "aria-live": "polite", message: value.Caption })),
            React.createElement(Icons_1.ChevronDownSmallIcon, null)),
        showWeekSearch && React.createElement(DropList_1.DropList, { PositionAbsolute: true, MaxHeight: 350, SearchAriaLabel: SearchAriaLabel, ShowSearch: true, OnSearch: handleOnSearch, OnSearchCancel: handleOnSearchCancel, OnCloseMenu: toggleWeekSearch, OnSelectRelative: handleSelectRelative, NoItemsMessage: Localization_1.strings.ChartRangeDropDownPicker_Message_SearchNoResultsFound, ref: dropListRef }, weeks.map(function (item) {
            var isSelected = (value.Caption === item.Caption);
            return (React.createElement(DropList_1.DropListItem, { key: item.Week + "-" + item.Year, Disabled: item.EndDate.valueOf() < MinSelectableDateNumber, Selected: isSelected, OnClick: function () { return handleWeekSelected(item); }, ref: function (el) {
                    if (isSelected) {
                        selectedListItemRef.current = el;
                    }
                } },
                React.createElement(Highlighted_1.Highlighted, { Text: item.Caption, Highlight: filter })));
        }))));
};
exports.WeekSelector = WeekSelector;
